import {
  SET_CENTROS_CUSTOS_ACTION,
  SET_SOLICITANTES_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_EMPRESA_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_GRUPO_ACTION,
} from './actions.type';
import {
  SET_CENTROS_CUSTOS,
  SET_SOLICITANTES,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_PRODUTO,
  SET_PROJETO,
  SET_GRUPO,
} from './mutations.type';

export default {
  [SET_CENTROS_CUSTOS_ACTION](context, centrosCustos) {
    context.commit(SET_CENTROS_CUSTOS, centrosCustos);
  },
  [SET_SOLICITANTES_ACTION](context, solicitantes) {
    context.commit(SET_SOLICITANTES, solicitantes);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_GRUPO_ACTION](context, grupo) {
    context.commit(SET_GRUPO, grupo);
  },
};
